import { GoalFilterDocument } from '@griply/types';
import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';

export const useUpdateGoalsOverviewFilterDocument = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (filterDocument: Partial<GoalFilterDocument>) =>
      updateSettings({
        filters: {
          goalsOverview: filterDocument,
        },
      }),
    [updateSettings],
  );
};
